<template>
  <section class="pageFlexBetweenWrap typeList">
    <div
      class="pageBigRadius pageCarServeShadow listItem"
      v-for="(item, index) in list"
      :key="index"
      :class="`${activeIndex === index ? 'active' : ''} ${
        canSel && item.productStock >= 1 ? '' : 'nosel'
      }`"
      @click="selItem(index)"
    >
      <div class="money" v-if="item.productIsAnyDeno != 1">
        <p class="pageFontWeight defaultMoney" v-if="status == null">
          {{ $formatMoney(Number(item.productDenomination), 1) }}元
        </p>
        <p class="pageFontWeight defaultMoney" v-else-if="status == 0">
          {{ $formatMoney(Number(item.productDenomination), 1) }}元
        </p>
        <p class="pageFontWeight defaultMoney" v-else>
          {{ item.productFlowVal }}
        </p>
        <p class="sellMoney">
          ￥{{ $formatMoney(Number(item.productCustomerPrice), 1)
          }}<span v-if="item.productStock <= 0">缺货</span>
        </p>
      </div>
      <div class="money" v-else>
        <p class="random">
          <font>￥</font>
          <van-field
            v-model="price"
            maxlength="4"
            type="number"
            class="random"
            @input="input"
            @focus="change"
            :disabled="item.productStock <= 0 || !canSel"
            ref="random"
            id="random"
          />
        </p>
        <p class="remark">任意面值</p>
        <p
          :class="'memberMoney ' + (price == 0 ? 'no' : '')"
          v-show="vip_discount > 0"
        >
          <font>￥{{ $formatMoney((vip_discount / 100) * price * 100) }}</font>
          <van-tag color="var(--depYelColor)" type="primary">VIP</van-tag>
        </p>
      </div>
      <van-icon v-if="activeIndex === index" class="icons" name="checked" />
      <!-- <span
        class="pageBadge discount"
        v-if="canSel && item.origin_price > item.sell_price"
      >惠</span>-->
    </div>
  </section>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [
        {
          id: 10028,
          is_default: 0,
          is_stock: 1,
          name: "电信30元手机话费充值",
          origin_price: 3500,
          sell_price: 3000,
          specs: "30",
          tips: "",
        },
        {
          id: 10028,
          is_default: 0,
          is_stock: 1,
          name: "电信30元手机话费充值",
          origin_price: 3500,
          sell_price: 3000,
          specs: "30",
          tips: "",
        },
        {
          id: 10028,
          is_default: 0,
          is_stock: 1,
          name: "电信30元手机话费充值",
          origin_price: 3500,
          sell_price: 3000,
          specs: "30",
          tips: "",
        },
        {
          id: 10028,
          is_default: 0,
          is_stock: 1,
          name: "电信30元手机话费充值",
          origin_price: 3500,
          sell_price: 3000,
          specs: "30",
          tips: "",
        },
      ],
    },
    activeIndex: {
      type: Number,
      default: null,
    },
    status: {
      type: Number,
      default: null,
    },
    canSel: {
      type: Boolean,
      default: true,
    },
    isMember: {
      type: Boolean,
      default: false,
    },
    vip_discount: Number,
  },
  data() {
    return {
      show: true,
      price: 0,
      index: 0,
      finaPrice: 0,
    };
  },
  mounted() {},
  methods: {
    input(val) {
      if (!/^\d+$/.test(val)) {
        this.price = this.price.replace(".", "").replace("-", "");
      }
      if (val > 0) {
        if (val > 1000) {
          this.price = 1000;
          this.$error("金额最大值为1000");
          this.$parent.sellData.sell_price = 0;
        } else {
          let num = 1;
          if (this.list.findIndex((item) => item.productIsAnyDeno === 1) >= 0) {
            num = this.list.find(
              (item) => item.productIsAnyDeno === 1
            ).productCustomerPrice;
          }
          this.finaPrice = this.price * num;
          this.selItem(this.index);
        }
      } else if (val == 0 || val != "") {
        this.price = "";
        // this.$error("金额不能为0");
        this.$parent.sellData.sell_price = -1;
      } else {
        this.$emit("selItem", this.index, 0);
      }
    },
    change() {
      if (this.price == "") {
        this.$parent.$refs.payway.btntext = "请输入任意金额";
      }
    },
    selItem(i) {
      if (this.list[i].productIsAnyDeno === 1) {
        this.$parent.sellData.sell_price = -1;
        var inputElem = document.getElementById("random");
        inputElem.focus();
      }
      if (this.canSel && this.list[i].productStock >= 1) {
        this.index = i;
        // this.activeIndex=i;
        if ((this.price > 0) & (this.list[i].productIsAnyDeno === 1)) {
          this.$emit("selItem", i, this.finaPrice, this.price);
        } else {
          this.$emit("selItem", i, 0, 0);
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.typeList {
  margin-top: -15px;
  .listItem {
    width: 30%;
    position: relative;
    margin-top: 15px;
    border: 2px solid transparent;
    background: #fff;
    color: var(--titleColor);
    padding: 5px 8px;
    box-sizing: border-box;
    .money {
      .remark {
        // font-size: 12px;
      }
      .random {
        display: flex;
        align-items: center;
        font {
          font-size: 14px;
        }
      }
      .van-cell::after {
        border-bottom: initial;
      }
      .van-cell {
        line-height: 24px;
        .van-field__control {
          color: #323233;
        }
      }
    }
    .random {
      padding: initial;
      font-size: 22px;
      font-weight: bold;
    }
    .defaultMoney {
      font-size: 22px;
    }
    .discount {
      position: absolute;
      top: -9px;
      right: -11px;
      width: 20px;
      height: 20px;
    }
    .icons {
      position: absolute;
      top: 3px;
      right: 4px;
      color: var(--redColor);
    }
    span {
      float: right;
    }
  }
  .listItem:last-child:nth-child(3n + 2) {
    margin-right: calc((100% - 30%) / 2);
  }
  .active {
    color: var(--redColor);
    border-color: var(--redColor);
    .memberMoney {
      color: var(--redColor);
    }
    /deep/ .van-field__control {
      color: var(--redColor);
    }
  }
  .nosel {
    border-color: transparent;
    color: #ddd;
    .memberMoney {
      color: #ddd;
      span {
        height: 15px;
        background-color: #ccc;
      }
    }
    /deep/ .van-field__control {
      color: #ddd;
    }
  }
  .delmoney {
    text-decoration: line-through;
    color: #cccccc;
  }
  .sellMoney {
    font-size: var(--pFont);
    span {
      float: right;
    }
  }
  .memberMoney {
    font-size: 14px;
    color: initial;
    display: flex;
    align-items: center;
    span {
      margin-left: 3px;
      float: initial;
      height: 15px;
      // background-image: linear-gradient(#ebedf0, #9198e5);
    }
  }
  .no {
    color: #fff !important;
    span {
      background: #fff !important;
    }
  }
}
</style>
